import { createSlice } from '@reduxjs/toolkit';
import axios from '../../config/axios-config';
import { setApiLoading, setApiSuccess, setApiError, ApiStatusKeys } from './apiStatusSlice';
import { handleApiError } from '../../helpers/errorHelper';

const initialState = {
  coach: null,
  loading: false,
  error: null,
};

const coachSlice = createSlice({
  name: 'coach',
  initialState,
  reducers: {
    setCoach: (state, action) => {
      state.coach = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearCoach: (state) => {
      state.coach = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setCoach, setLoading, setError, clearCoach } = coachSlice.actions;

export const getCoachById = (coachId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    dispatch(setApiLoading(ApiStatusKeys.GET_COACH));

    const response = await axios({
      method: 'get',
      url: '/coach/get-coach-by-id',
      params: { id: coachId },
    });

    if (response.data.success) {
      dispatch(setApiSuccess(ApiStatusKeys.GET_COACH));
      dispatch(setCoach(response.data.coach));
    } else {
      throw new Error(response.data.errorMessage);
    }
  } catch (error) {
    handleApiError(error, ApiStatusKeys.GET_COACH, dispatch, 'errors.coach_failed');
    throw error;
  }
};

export default coachSlice.reducer;
